import { ColumnsType } from 'antd/lib/table'
import formatNumber from '../../../../helpers/formatters/format-any-number'
import RewindQueueEntry from '../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../types/api/shipment-position'
import { MaterialColumnCell } from '../../../schedules/flexo/components/cells/material-column-cell'
import { getShipmentFloods } from '../../../schedules/rewind/helpers/get-shipment-floods'
import ActionsCell from './components/actions-cell'

export const columns: ColumnsType<RewindQueueEntry> = [
    {
        dataIndex: ['rewind_job', 'id'],
        title: 'Номер',
        width: 60,
        render: value => value || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'print_job', 'id'],
        title: 'Задание печати',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 110,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Ручьи',
        width: 70,
        render: (_value: ShipmentPosition[], record) => {
            const floods = getShipmentFloods(record.rewind_job?.shipment)

            return floods ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'stamp', 'number'],
        title: 'Номер штампа',
        width: 100,
        render: (_value, record) => {
            const stamp = record.rewind_job?.shipment?.stamp

            return stamp?.number || '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 90,
        render: (_value, record) =>
            formatNumber(
                (record.rewind_job?.shipment?.shipment_positions || []).reduce(
                    (acc, position) => acc + (position.copies || 0),
                    0
                )
            ),
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        width: 400,
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
